import { BaseUrl } from '@/helpers/BaseUrl';
import { lsGet } from '@/helpers/localStorageHelper';
import { hasPermsCheck } from '@/helpers/permissionCheck';
import adminAxios from '@/plugins/axios';
import { defineStore } from 'pinia';
import { createCrudActions } from './baseCrud';

const baseRoleUrl = BaseUrl.get('role');

function readPermissions() {
  const raw = lsGet('permission');
  if (!raw || raw === 'undefined' || raw === 'null') {
    return [];
  }
  try {
    return JSON.parse(raw) ?? [];
  } catch {
    return [];
  }
}

export const useRoleStore = defineStore('role', {
  state: () => {
    return {
      permissions: readPermissions(),
    };
  },
  getters: {
    getPermissions() {
      return this.permissions;
    },
  },
  actions: {
    ...createCrudActions(baseRoleUrl),
    checkNavPerm(item) {
      const userData = lsGet('userData', true) || null;
      if (!userData) {
        return false;
      }
      if (userData?.is_super_admin) {
        return true;
      }

      let hasPerm = true;

      let perms = item.perm || item.perms || (item.children ? item.children.map(i => i.perm).filter(p => p) : []);
      perms = Array.isArray(perms) ? perms : [perms];

      if (perms?.length > 0) {
        hasPerm = perms.some(perm => {
          if (!userData) {
            return false;
          }

          let ps = perm.split('.');

          return this.hasPerms(ps[0], ps[1] || 'list');
        });
      }

      return hasPerm;
    },
    hasPerms(cls, perms) {
      const userData = lsGet('userData', true) || null;
      return hasPermsCheck(this.permissions, userData?.is_super_admin, cls, perms);
    },
    async getRolePermissions(roleId) {
      try {
        const response = await adminAxios.get(`${baseRoleUrl}/${roleId}`);

        return response.data.data.permissions;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async getPermissionsSets() {
      try {
        const response = await adminAxios.get(`${baseRoleUrl}/permission/set`);

        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async updateRolePermissions(roleId, roleUuid, payload) {
      try {
        return await adminAxios.put(`${baseRoleUrl}/${roleId}/perm?uuid=${roleUuid}`, {
          permissions: payload,
        });
      } catch (error) {
        return await Promise.reject(error);
      }
    },
  },
});
